import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
import { ZapIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full pt-12 pb-16 md:pt-24 md:pb-32 px-4 md:px-5 overflow-hidden" data-id="element-55">
      {/* Radial glow — smaller on mobile */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-[300px] md:w-[800px] md:h-[600px] pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(255,107,0,0.08) 0%, transparent 70%)'
    }} data-id="element-56" />

      <div className="relative max-w-3xl mx-auto" data-id="element-57">
        {/* Eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.35,
        delay: 0.05
      }} className="flex items-center gap-2 mb-6 md:mb-8" data-id="element-58">
          <ZapIcon className="w-4 h-4 text-accent" data-id="element-59" />
          <span className="text-xs md:text-sm font-semibold tracking-[0.2em] uppercase text-accent" data-id="element-60">
            Hook Arsenal — Meta Reels
          </span>
        </motion.div>

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.1
      }} className="text-3xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.08] tracking-tight mb-5 md:mb-6" data-id="element-61">
          200 ganchos en Español MX para{' '}
          <span className="text-accent" data-id="element-62">detener el scroll</span> en 3 segundos
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.18
      }} className="text-lg md:text-2xl text-neutral-400 leading-relaxed mb-8 md:mb-10 max-w-2xl" data-id="element-63">
          Deja de empezar con "Hola": usa la{' '}
          <span className="text-white font-semibold" data-id="element-64">Fórmula 1–3–1</span> y haz
          que se queden
        </motion.p>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.25
      }} data-id="element-65">
          <CTAButton href="#pricing" data-id="element-66">Quiero HOOK ARSENAL</CTAButton>
        </motion.div>

        {/* Opening Lead */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="mt-16 md:mt-32 space-y-5 md:space-y-6 text-base md:text-xl leading-relaxed text-neutral-300" data-id="element-67">
          <p data-id="element-68">
            Si tus Reels se quedan con 200 vistas, no es porque "la gente no te
            apoya"…
          </p>
          <p className="text-white font-bold text-lg md:text-2xl" data-id="element-69">
            es porque tu primer segundo no les da una razón para quedarse.
          </p>
          <div className="space-y-1 pt-2" data-id="element-70">
            <p data-id="element-71">Y lo peor: tú sí tienes contenido.</p>
            <p data-id="element-72">Tú sí te esfuerzas.</p>
            <p data-id="element-73">
              Pero estás entrando como si estuvieras{' '}
              <span className="font-serif-italic text-accent-light text-xl md:text-2xl" data-id="element-74">
                pidiendo permiso.
              </span>
            </p>
          </div>
          <div className="pt-4 border-l-2 border-accent/40 pl-5 md:pl-6 space-y-2" data-id="element-75">
            <p data-id="element-76">Meta no premia al que "hace buen contenido".</p>
            <p className="text-white font-bold" data-id="element-77">
              Premia al que{' '}
              <span className="text-accent" data-id="element-78">gana atención rápido.</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}